import React from "react";


const Bake = () => {
  return (
    <div>
      {/* <section className="best-features-area section-padd4">
                <div className="container">
                    <div className="row justify-content-end">
                        <div className="col-xl-8 col-lg-10">
                            <div className="row">
                                <div className="col-lg-10 col-md-10">
                                    <div className="section-tittle">
                                        <h2>Some of the best features Of Our App!</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6">
                                    <div className="single-features mb-70">
                                        <div className="features-icon">
                                            <span className="flaticon-support" />
                                        </div>
                                        <div className="features-caption">
                                            <h3>Easy to Costomize</h3>
                                            <p>
                                                Aorem psum olorsit amet ectetur adipiscing elit, sed dov.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6">
                                    <div className="single-features mb-70">
                                        <div className="features-icon">
                                            <span className="flaticon-support" />
                                        </div>
                                        <div className="features-caption">
                                            <h3>Extreme Security</h3>
                                            <p>
                                                Aorem psum olorsit amet ectetur adipiscing elit, sed dov.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6">
                                    <div className="single-features mb-70">
                                        <div className="features-icon">
                                            <span className="flaticon-support" />
                                        </div>
                                        <div className="features-caption">
                                            <h3>Customer Support</h3>
                                            <p>
                                                Aorem psum olorsit amet ectetur adipiscing elit, sed dov.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6">
                                    <div className="single-features mb-70">
                                        <div className="features-icon">
                                            <span className="flaticon-support" />
                                        </div>
                                        <div className="features-caption">
                                            <h3>Creative Design</h3>
                                            <p>
                                                Aorem psum olorsit amet ectetur adipiscing elit, sed dov.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="features-shpae d-none d-lg-block">
                    <img
                        src="./App Landing Template_files/xbest-features.png.pagespeed.ic.-EurwAn5bC.webp"
                        alt=""
                    />
                </div>
            </section>
            <section className="service-area sky-blue section-padding2">
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-tittle text-center">
                                <h2>
                                    How Can We HelpYour
                                    <br />
                                    with Appco!
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="services-caption text-center mb-30">
                                <div className="service-icon">
                                    <span className="flaticon-businessman" />
                                </div>
                                <div className="service-cap">
                                    <h4>
                                        <a href="https://preview.colorlib.com/theme/appco/#">
                                            Easily Manage
                                        </a>
                                    </h4>
                                    <p>
                                        Sorem spsum dolor sit amsectetur adipisclit, seddo eiusmod
                                        tempor incididunt ut laborea.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="services-caption active text-center mb-30">
                                <div className="service-icon">
                                    <span className="flaticon-pay" />
                                </div>
                                <div className="service-cap">
                                    <h4>
                                        <a href="https://preview.colorlib.com/theme/appco/#">
                                            Get Payments Easily
                                        </a>
                                    </h4>
                                    <p>
                                        Sorem spsum dolor sit amsectetur adipisclit, seddo eiusmod
                                        tempor incididunt ut laborea.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="services-caption text-center mb-30">
                                <div className="service-icon">
                                    <span className="flaticon-plane" />
                                </div>
                                <div className="service-cap">
                                    <h4>
                                        <a href="https://preview.colorlib.com/theme/appco/#">
                                            Quick Messaging
                                        </a>
                                    </h4>
                                    <p>
                                        Sorem spsum dolor sit amsectetur adipisclit, seddo eiusmod
                                        tempor incididunt ut laborea.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="applic-apps section-padding2">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <div className="single-cases-info mb-30">
                                <h3>
                                    Applic Apps
                                    <br /> Screenshot
                                </h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consecadipiscing elit, sed do eiusmod
                                    tempor incididunt ut ore et dolore magna aliqua. Quis ipsum
                                    suspendisse gravida. Risus commodo viverra maecenasan lacus vel
                                    facilisis.{" "}
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-col-md-7">
                            <div className="app-active owl-carousel owl-loaded owl-drag">
                                <div className="owl-stage-outer">
                                    <div
                                        className="owl-stage"
                                        style={{
                                            transform: "translate3d(-2278px, 0px, 0px)",
                                            transition: "all 2s ease 0s",
                                            width: 7404
                                        }}
                                    >
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp3.png.pagespeed.ic.AlofEJC5tu.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp1.png.pagespeed.ic.Iz5rAscd9N.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item active"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp1.png.pagespeed.ic.Iz5rAscd9N.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item active"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item active"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp3.png.pagespeed.ic.AlofEJC5tu.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item active"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp1.png.pagespeed.ic.Iz5rAscd9N.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp1.png.pagespeed.ic.Iz5rAscd9N.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp3.png.pagespeed.ic.AlofEJC5tu.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="owl-item cloned"
                                            style={{ width: "554.5px", marginRight: 15 }}
                                        >
                                            <div className="single-cases-img">
                                                <img
                                                    src="./App Landing Template_files/xApp2.png.pagespeed.ic.JbwxSe9pMq.webp"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="owl-nav disabled">
                                    <div className="owl-prev">
                                        <i className="fas fa-arrow-left" />
                                    </div>
                                    <div className="owl-next">
                                        <i className="fas fa-arrow-right" />
                                    </div>
                                </div>
                                <div className="owl-dots disabled" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section
                className="best-pricing pricing-padding"
                data-background="assets/img/gallery/best_pricingbg.jpg"
                style={{ backgroundImage: 'url("assets/img/gallery/best_pricingbg.jpg")' }}
            >
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-lg-6 col-md-8">
                            <div className="section-tittle section-tittle2 text-center">
                                <h2>Choose Your Very Best Pricing Plan.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="pricing-card-area">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="single-card text-center mb-30">
                                <div className="card-top">
                                    <span>2 Years</span>
                                    <h4>
                                        $05 <span>/ month</span>
                                    </h4>
                                </div>
                                <div className="card-bottom">
                                    <ul>
                                        <li>Increase traffic 50%</li>
                                        <li>E-mail support</li>
                                        <li>10 Free Optimization</li>
                                        <li>24/7 support</li>
                                    </ul>
                                    <a
                                        href="https://preview.colorlib.com/theme/appco/services.html"
                                        className="btn card-btn1"
                                    >
                                        Get Started
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="single-card  text-center mb-30">
                                <div className="card-top">
                                    <span>2 Years</span>
                                    <h4>
                                        $05 <span>/ month</span>
                                    </h4>
                                </div>
                                <div className="card-bottom">
                                    <ul>
                                        <li>Increase traffic 50%</li>
                                        <li>E-mail support</li>
                                        <li>10 Free Optimization</li>
                                        <li>24/7 support</li>
                                    </ul>
                                    <a
                                        href="https://preview.colorlib.com/theme/appco/services.html"
                                        className="btn card-btn1"
                                    >
                                        Get Started
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="single-card text-center mb-30">
                                <div className="card-top">
                                    <span>2 Years</span>
                                    <h4>
                                        $05 <span>/ month</span>
                                    </h4>
                                </div>
                                <div className="card-bottom">
                                    <ul>
                                        <li>Increase traffic 50%</li>
                                        <li>E-mail support</li>
                                        <li>10 Free Optimization</li>
                                        <li>24/7 support</li>
                                    </ul>
                                    <a
                                        href="https://preview.colorlib.com/theme/appco/services.html"
                                        className="btn card-btn1"
                                    >
                                        Get Started
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="our-customer section-padd-top30">
                <div className="container-fluid">
                    <div className="our-customer-wrapper">
                        <div className="row d-flex justify-content-center">
                            <div className="col-xl-8">
                                <div className="section-tittle text-center">
                                    <h2>
                                        What Our Customers
                                        <br /> Have to Say
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="customar-active dot-style d-flex dot-style slick-initialized slick-slider slick-dotted">
                                    <div
                                        className="slick-list draggable"
                                        style={{ padding: "0px 50px" }}
                                    >
                                        <div
                                            className="slick-track"
                                            style={{
                                                opacity: 1,
                                                width: 12288,
                                                transform: "translate3d(-6144px, 0px, 0px)"
                                            }}
                                        >
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={-4}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman1.png.pagespeed.ic.8HTRy7BdVV.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={-3}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={-2}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman3.png.pagespeed.ic.WFZnwsu9sH.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned slick-center"
                                                data-slick-index={-1}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide"
                                                data-slick-index={0}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                role="tabpanel"
                                                id="slick-slide10"
                                                aria-describedby="slick-slide-control10"
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman1.png.pagespeed.ic.8HTRy7BdVV.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide"
                                                data-slick-index={1}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                role="tabpanel"
                                                id="slick-slide11"
                                                aria-describedby="slick-slide-control11"
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-active"
                                                data-slick-index={2}
                                                aria-hidden="false"
                                                tabIndex={-1}
                                                role="tabpanel"
                                                id="slick-slide12"
                                                aria-describedby="slick-slide-control12"
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman3.png.pagespeed.ic.WFZnwsu9sH.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={0}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-current slick-active slick-center"
                                                data-slick-index={3}
                                                aria-hidden="false"
                                                tabIndex={0}
                                                role="tabpanel"
                                                id="slick-slide13"
                                                aria-describedby="slick-slide-control13"
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={0}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned slick-active"
                                                data-slick-index={4}
                                                aria-hidden="false"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman1.png.pagespeed.ic.8HTRy7BdVV.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={0}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={5}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={6}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman3.png.pagespeed.ic.WFZnwsu9sH.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                className="single-customer mb-100 slick-slide slick-cloned"
                                                data-slick-index={7}
                                                aria-hidden="true"
                                                tabIndex={-1}
                                                style={{ width: 994 }}
                                            >
                                                <div className="what-img">
                                                    <img
                                                        src="./App Landing Template_files/xman2.png.pagespeed.ic.9QnQkd8vT9.webp"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="what-cap">
                                                    <h4>
                                                        <a
                                                            href="https://preview.colorlib.com/theme/appco/#"
                                                            tabIndex={-1}
                                                        >
                                                            Welcome To The Best Model Winner Contest
                                                        </a>
                                                    </h4>
                                                    <p>
                                                        Utenim ad minim veniam quisnostrud exercitation
                                                        ullamcolabor nisiut aliquip ex ea commodo consequat duis
                                                        aute irure dolor in represse.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul
                                        className="slick-dots"
                                        style={{ display: "block" }}
                                        role="tablist"
                                    >
                                        <li className="" role="presentation">
                                            <button
                                                type="button"
                                                role="tab"
                                                id="slick-slide-control10"
                                                aria-controls="slick-slide10"
                                                aria-label="1 of 2"
                                                tabIndex={-1}
                                            >
                                                1
                                            </button>
                                        </li>
                                        <li role="presentation">
                                            <button
                                                type="button"
                                                role="tab"
                                                id="slick-slide-control11"
                                                aria-controls="slick-slide11"
                                                aria-label="2 of 2"
                                                tabIndex={-1}
                                            >
                                                2
                                            </button>
                                        </li>
                                        <li role="presentation">
                                            <button
                                                type="button"
                                                role="tab"
                                                id="slick-slide-control12"
                                                aria-controls="slick-slide12"
                                                aria-label="3 of 2"
                                                tabIndex={-1}
                                            >
                                                3
                                            </button>
                                        </li>
                                        <li className="slick-active" role="presentation">
                                            <button
                                                type="button"
                                                role="tab"
                                                id="slick-slide-control13"
                                                aria-controls="slick-slide13"
                                                aria-label="4 of 2"
                                                tabIndex={0}
                                                aria-selected="true"
                                            >
                                                4
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="available-app-area">
                <div className="container">
                    <div className="row d-flex justify-content-between">
                        <div className="col-xl-5 col-lg-6">
                            <div className="app-caption">
                                <div className="section-tittle section-tittle3">
                                    <h2>Our App Available For Any Device Download now</h2>
                                    <p>
                                        Duis aute irure dolor in reprehenderit in voluptate velit esse
                                        cillum dolore fug.
                                    </p>
                                    <div className="app-btn">
                                        <a
                                            href="https://preview.colorlib.com/theme/appco/#"
                                            className="app-btn1"
                                        >
                                            <img
                                                src="./App Landing Template_files/xapp_btn1.png.pagespeed.ic.YpLN5QcG95.webp"
                                                alt=""
                                            />
                                        </a>
                                        <a
                                            href="https://preview.colorlib.com/theme/appco/#"
                                            className="app-btn2"
                                        >
                                            <img
                                                src="./App Landing Template_files/xapp_btn2.png.pagespeed.ic._NK39AKizi.webp"
                                                alt=""
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="app-img">
                                <img
                                    src="./App Landing Template_files/xavailable-app.png.pagespeed.ic.AJNBEefGH7.webp"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="app-shape">
                    <img
                        src="./App Landing Template_files/xapp-shape-top.png.pagespeed.ic.vP4747NW-d.webp"
                        alt=""
                        className="app-shape-top heartbeat d-none d-lg-block"
                    />
                    <img
                        src="./App Landing Template_files/xapp-shape-left.png.pagespeed.ic.S1YjF5wvGa.webp"
                        alt=""
                        className="app-shape-left d-none d-xl-block"
                    />
                </div>
            </div>
            <div className="say-something-aera pt-90 pb-90 fix">
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="offset-xl-1 offset-lg-1 col-xl-5 col-lg-5">
                            <div className="say-something-cap">
                                <h2>Say Hello To The Collaboration Hub.</h2>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-3">
                            <div className="say-btn">
                                <a
                                    href="https://preview.colorlib.com/theme/appco/#"
                                    className="btn radius-btn"
                                >
                                    Contact Us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="say-shape">
                    <img
                        src="./App Landing Template_files/xsay-shape-left.png.pagespeed.ic.lpmVustF7k.webp"
                        alt=""
                        className="say-shape1 rotateme d-none d-xl-block"
                    />
                    <img
                        src="./App Landing Template_files/xsay-shape-right.png.pagespeed.ic.eTuVF_bJv6.webp"
                        alt=""
                        className="say-shape2 d-none d-lg-block"
                    />
                </div>
            </div> */}




    </div>
  );
};

export default Bake;
